<template>
  <div class="modal fade" :class="{ 'show': postShow, 'modal-static': backDropAnim }" v-if="preShow" style="display: block;" @click="backDropClick">
    <div class="modal-dialog" :class="(size ? 'modal-' + size : '')">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h5 class="modal-title" id="formLabel" v-text="title"></h5>
          <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">Close</button>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>

  <div v-if="preShow" class="modal-backdrop fade" :class="{ 'show': postShow }"></div>
</template>

<script>
export default {
  props: ['show', 'backdrop', 'title', 'config', 'size'],
  emits: ['close'],
  data() {
    return {
      preShow: false,
      postShow: false,
      backDropAnim: false
    }
  },
  watch: {
    show() {
      if(this.show) {
        this.preShow = this.show;
        setTimeout(() => {
          this.postShow = this.show;
        }, 250);
      } else {
        this.close();
      }
    }
  },
  mounted() {
    this.postShow = this.show;
  },
  methods: {
    close(e) {
      this.postShow = false
      setTimeout(() => {
        this.preShow = false;
        this.$emit('close', e);
      }, 250);
    },
    backDropClick(e) {
      if(this.backdrop == 'static') {
        this.backDropAnim = true;
        setTimeout(() => {
          this.backDropAnim = false;
        }, 250);
      } else {
        this.close(e);
      }
    }
  }
}
</script>